var keyword = "";
var itemListTmpl;
var noVideoResults = false;
var noGameResults = false;
$(document).ready(function()
{
	$(".header-search").addClass("open-search").removeClass("close-search"); 
	$(".search").addClass("open-input");
	itemListTmpl = Handlebars.compile($("#itemListTemplate").html());
	if(config.SOLR_GAME)
	{
		renderRecommendedGames();
	}
	keyword = $(":input[name='keyword']").val();
	if(keyword) {
		var query = encodeURIComponent(keyword);
		renderSearchVideos(query);
		if(config.SOLR_GAME)
		{
			renderSearchGames(query);
		}
	}
});

function renderRecommendedGames()
{
	window.getRecommendedGames(null, function(data){
		var sectionData = {};
		sectionData.sectionTitle = NEU.util.getLocalizedString("search_game_recommended");
		sectionData.itemDataType = "game";
		sectionData.itemList = window.processSectionItems(data, "game");
		sectionData.hasItemsData = sectionData.itemList.length > 0 ? true : false;
		var html = itemListTmpl(sectionData);
		$("#recommendedGames").html(html);
		initSectionItemFunctions();
	});
}

function renderSearchVideos(query)
{
	window.getSOLRData("program", query, function (data)
	{
		if(data.length > 0)
		{
			var sectionData = {};
			sectionData.sectionTitle = NEU.util.getLocalizedString("search_videos_title");
			sectionData.itemDataType = "program";
			sectionData.itemList = window.processSectionItems(data, "program");
			sectionData.hasItemsData = true;
			var html = itemListTmpl(sectionData);
			$("#searchVideos").html(html);
			initSectionItemFunctions();
		}
		else 
		{
			noVideoResults = true;
			showNoResults();
		}
	});
}

function renderSearchGames(query)
{
	window.getSOLRData("game", query, function (data)
	{
		if(data.length > 0)
		{
			var sectionData = {};
			sectionData.sectionTitle = NEU.util.getLocalizedString("search_games_title");
			sectionData.itemDataType = "game";
			sectionData.itemList = window.processSectionItems(data, "game");
			sectionData.hasItemsData = sectionData.itemList.length > 0 ? true : false;
			var html = itemListTmpl(sectionData);
			$("#searchGames").html(html);
			initSectionItemFunctions();
		}
		else 
		{
			noGameResults = true;
			showNoResults()
		}
	});
}

function showNoResults()
{
	if((noVideoResults && noGameResults) || (noVideoResults && config.SOLR_GAME === ""))
	{
		var searchKeyword = $(":input[name='keyword']").val();
		$("#searchResultTitle").html(NEU.util.getLocalizedString("search_no_results").replace(new RegExp('{{keyword}}', "g"), searchKeyword));
	}
}